import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { PrecastPrintTableComponent } from './precast-print-table/precast-print-table.component';
import { PrecastPrintRoutingModule } from './precast-print-routing.module';

@NgModule({
  declarations: [
    PrecastPrintTableComponent
  ],
  imports: [
    CommonModule,
    PrecastPrintRoutingModule,
    MatTableModule,
    MatCheckboxModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
  ]
})
export class PrecastPrintModule  { }
